import "vue-rx";
import { TranslationStore } from "./translation/TranslationStore";
import { map } from "rxjs/operators";
import { SYM_ROOT_CONTAINER } from "../di";
import { normalizeI18nKey } from "./util";
import { LocalizationContext } from "./context";
import { TranslationEditorContext } from "./translation/editor/TranslationEditorContext";
const ROOT_TRANSLATION_EDITOR_STATE_KEY = "$$translationEditorState";
const ROOT_TRANSLATIONS_PROPERTY_KEY = "$$translations";
const ROOT_I18N_PROPERTY_KEY = "$$i18n";
/**
 * i18n plugin for Vue.js applications.
 * <br>⚠ Requires the `CoreI18nModule` to be installed and configured.
 * <br>
 * <br>This plugin adds the following properties to component instances:
 * <br>- `$t()`: a function to translate a textual resource from its identifier
 * <br>- `$i18n`: allows to know the locale and the currency of the user, as well as the different locales supported by the application
 *
 * @param config The configuration of the plugin
 */
export function I18nPlugin(config) {
    return {
        install: (_Vue) => {
            _Vue.mixin({
                beforeCreate() {
                    if (this.$root === this) {
                        const { subscriptions = () => { }, } = this.$options;
                        const container = this[SYM_ROOT_CONTAINER];
                        const translationStore = container.get(TranslationStore);
                        const translationsObservableSource = translationStore.value$.pipe(map(s => s.translations));
                        const localizationContext = container.get(LocalizationContext);
                        const localizationContextObservableSource = localizationContext.value$.pipe(map(s => ({
                            currency: s.currentCurrency,
                            locale: s.currentLocale,
                            supportedLocales: s.wellKnownLocales,
                        })));
                        const translationEditorContext = container.get(TranslationEditorContext);
                        const translationEditorObservableSource = translationEditorContext.value$;
                        this.$options.subscriptions = function () {
                            return {
                                [ROOT_TRANSLATION_EDITOR_STATE_KEY]: translationEditorObservableSource,
                                [ROOT_TRANSLATIONS_PROPERTY_KEY]: translationsObservableSource,
                                [ROOT_I18N_PROPERTY_KEY]: localizationContextObservableSource,
                                ...subscriptions.bind(this)(),
                            };
                        };
                    }
                },
            });
            Object.defineProperty(_Vue.prototype, "$i18n", {
                get() {
                    return this.$root[ROOT_I18N_PROPERTY_KEY];
                },
            });
            if (config.env === "production") {
                _Vue.prototype.$t = function (key) {
                    const normalizedKey = normalizeI18nKey(key);
                    const translation = this.$root[ROOT_TRANSLATIONS_PROPERTY_KEY].get(normalizedKey);
                    return translation ?? "";
                };
            }
            else {
                _Vue.prototype.$t = function (key) {
                    const normalizedKey = normalizeI18nKey(key);
                    const translation = this.$root[ROOT_TRANSLATIONS_PROPERTY_KEY].get(normalizedKey);
                    const translationEditorState = this.$root[ROOT_TRANSLATION_EDITOR_STATE_KEY];
                    if (!translation || translationEditorState.enabled) {
                        return `[${normalizedKey}]`;
                    }
                    else {
                        return translation;
                    }
                };
            }
        },
    };
}
//# sourceMappingURL=plugin.js.map